module.exports = __webpack_public_path__ + "img/61200.c79c6306.jpg";